import {
  Avatar,
  Col,
  colors,
  HoverCard,
  Icon,
  Row,
  Space,
  spacing,
  Tag,
  Text,
} from 'common-components'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

const HeaderContainer = styled(Row)`
  padding-top: ${spacing.padding.card.default}px;
  padding-left: ${spacing.padding.card.default}px;
  padding-right: ${spacing.padding.card.default}px;
  min-height: 39px;
`
const ContentContainer = styled(Col)`
  padding: ${spacing.padding.card.default}px;
  min-height: 99px;
`
const FooterContainer = styled(Row)`
  width: 100%;
  height: 56px;
`
const HoverContentContainer = styled(Row)`
  width: 100%;
  color: white;
`

// TODO HIDE not remove
// const DraftBadgeContainer = styled.div`
//   position: absolute;
//   height: 50px;
//   width: 110px;
//   padding: 5px;
//   top: -45px;
//   right: -37px;
//   transform: rotate(45deg);
//   background-color: ${colors.gray600};
// `

type CardPropsType = {
  card: { name: string }
  onClick?: () => void
  style?: unknown
}

const Card = function ({ card, onClick, style }: CardPropsType) {
  return (
    <HoverCard
      HeaderComponent={
        <HeaderContainer align={'middle'} justify={'space-between'}>
          <div
            style={{ cursor: 'pointer' }}
            css={css`
              font-weight: 500;
              font-size: 16px;
              color: #101828;
              line-height: 24px;
            `}
          >
            {card.name}
          </div>
        </HeaderContainer>
      }
      ContentComponent={
        <ContentContainer>
          {/*FIXME: should be only in conditions specified by BE. Disabled for now*/}
          {/*<DraftBadgeContainer>*/}
          {/*	<div*/}
          {/*		css={css`*/}
          {/*			margin-top: 2px;*/}
          {/*			display: flex;*/}
          {/*			flex-direction: column;*/}
          {/*			align-items: center;*/}
          {/*		`}*/}
          {/*	>*/}
          {/*		<Icon icon={"Lock01"} color={colors.white} />*/}
          {/*		<Text color={colors.white}>Réservé</Text>*/}
          {/*	</div>*/}
          {/*</DraftBadgeContainer>*/}
          <Space direction='vertical'>
            <Tag
              css={css`
                display: flex;
                gap: 5px;
                padding: 4px;
              `}
            >
              <Icon height={16} width={16} icon='ParagraphWrap' color='#344054' />
              <Text
                css={css`
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 20px;
                  color: #344054;
                `}
              >
                Redaction de contenu
              </Text>
            </Tag>
            {/*<Text*/}
            {/*	css={css`*/}
            {/*		font-weight: 500 !important;*/}
            {/*		font-size: 12px;*/}
            {/*		line-height: 18px;*/}
            {/*		color: #2e90fa !important;*/}
            {/*	`}*/}
            {/*>*/}
            {/*	Fin du boost dans 3 heures*/}
            {/*</Text>*/}
          </Space>
        </ContentContainer>
      }
      footerContent={
        <FooterContainer align={'middle'} justify={'space-between'}>
          <Avatar size='sm' />
          {/*FIXME: NO DATA FOR SEGMENTS*/}
          {/*<div*/}
          {/*	css={css`*/}
          {/*		margin-left: 30px;*/}
          {/*	`}*/}
          {/*>*/}
          {/*	<IconAvatarGroup*/}
          {/*		avatars={card.segments.slice(0, 2).map((segment) => {*/}
          {/*			return {*/}
          {/*				size: "sm",*/}
          {/*				icon: "Scale02",*/}
          {/*				iconColor: colors.success500,*/}
          {/*				borderColor: colors.white,*/}
          {/*				iconBackground: colors.success300,*/}
          {/*			};*/}
          {/*		})}*/}
          {/*		maxCount={2}*/}
          {/*	/>*/}
          {/*</div>*/}
          <div
            css={css`
              display: flex;
              align-items: center;
              gap: 10px;
            `}
          >
            <Icon icon={'ClockStopwatch'} color={colors.gray600} />
            {/*<Text*/}
            {/*	css={css`*/}
            {/*		color: ${colors.gray600};*/}
            {/*	`}*/}
            {/*>*/}
            {/*	{card.duration}*/}
            {/*</Text>*/}
          </div>
        </FooterContainer>
      }
      hoverFooterContent={<HoverContentContainer align={'middle'} justify={'center'} />}
      onClick={onClick}
      style={style}
    />
  )
}

export default Card
